export default __webpack_public_path__ + "static/media/news31.c8f7d60a.jpg";